import React from 'react';
import ErrorPage from 'CMPT/common/ErrorPage';

export default function NotFound() {
    return (
        <ErrorPage />
    )
}